import React from "react";
import SwitchToggle from "../../components/SwitchToggle";
import { useNavigate, useLocation } from "react-router-dom";

const ViewProgram = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const program = (location.state && location.state.program) || {
    title: "Full Body Transformation",
    thumbnail: "/static/images/program_placeholder.png",
    duration: "12 Weeks",
    difficulty: "Intermediate",
    enrolledUsers: 45,
    description: "A complete full body workout program to increase strength and stamina.",
    goals: "Strength, Stamina",
    equipment: "Dumbbells, Mat",
    createdDate: "30 July 2025",
    status: true,
  };

  return (
    <>
      <div className="main_title">
        <h1>Program Details</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-programs")}>Manage Programs</button> - View Program
        </p>
      </div>

      <div className="cards">
        <div className="view_page">
          <div className="gap_p">

            {/* Thumbnail */}
            <div className="w_33">
              <h6>Program Thumbnail</h6>
              <p>
                <img 
                  src={program.thumbnail} 
                  alt={program.title} 
                  style={{ width: "100%", objectFit: "contain" }} 
                />
              </p>
            </div>

            {/* Title */}
            <div className="w_33">
              <h6>Program Title</h6>
              <p>{program.title}</p>
            </div>

            {/* Duration */}
            <div className="w_33">
              <h6>Duration</h6>
              <p>{program.duration}</p>
            </div>

            {/* Difficulty */}
            <div className="w_33">
              <h6>Difficulty</h6>
              <p>{program.difficulty}</p>
            </div>

            {/* Enrolled Users */}
            <div className="w_33">
              <h6>Enrolled Users</h6>
              <p>{program.enrolledUsers}</p>
            </div>

            {/* Created Date */}
            <div className="w_33">
              <h6>Created Date</h6>
              <p>{program.createdDate}</p>
            </div>

            {/* Status */}
            <div className="w_33">
              <h6>Status</h6>
              <p>
                <SwitchToggle defaultChecked={program.status} />
              </p>
            </div>

            {/* Description */}
            <div className="w_100">
              <h6>Description</h6>
              <p>{program.description}</p>
            </div>

            {/* Goals */}
            <div className="w_100">
              <h6>Goals</h6>
              <p>{program.goals}</p>
            </div>

            {/* Equipment Needed */}
            <div className="w_100">
              <h6>Equipment Needed</h6>
              <p>{program.equipment}</p>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ViewProgram;
